import { combineReducers } from "redux";
import authReducer from "../auth/AuthReducer";
import alertReducer from "../common/components/alert/AlertReducer";

export default combineReducers({
  auth: authReducer,
  alert: alertReducer
});
